import './index.less';
import { withInstall } from '@mts-fe/utils';
import _Divider from './Divider';

export type { DividerContentPosition, DividerProps } from './Divider';
export const Divider = withInstall(_Divider);
